import {translateArray} from './translateArray.js';
import {translateObject} from './translateObject.js';
import {isString} from './isString.js';
import {isArray} from './isArray.js';
import {isTrueObject} from './isTrueObject.js';
import {renderReactComponentsToString} from "./renderReactComponentsToString";
import * as Sentry from "@sentry/browser";

export const translate = (t, key, params) => {

    if (!key) {
        return undefined;
    } else if (typeof key == "boolean") {
        return key;
    } else if (isString(key)) {
        const convertedParams = params ? renderReactComponentsToString(params) : null; //replace possible react components with strings

        if (convertedParams && isArray(convertedParams.defaultValue)) {
            // prevent error: key returned an object instead of string
            // Special case for arrays with an array as default value.
            // Example: t(['a', 'b'], {defaultValue: t(['a', 'b'], {ns: 'Errors'})})
            // First call of translate goes to translateArray, which calls translate again for each element with tranlate(t, key, {index, defaultValue: t(['a', 'b'], {ns: 'Errors'})})
            // If then no key is found the defaultValue is returned which is an array and causes an error since not a string.
            const index = convertedParams.defaultValue.length > convertedParams.index ? convertedParams.index : 0;
            convertedParams.defaultValue = convertedParams.defaultValue[index];
        }
        return t(key, convertedParams);
    } else if (isArray(key)) {
        if (key.length === 0) {
            return '';
        }
        return translateArray(t, key, params);
    } else if (isTrueObject(key)) {  // should not be used
        return translateObject(t, key, params);
    } else {
        Sentry.captureException('Invalid key type in translate.js. Key with type ', typeof key, ' was passed to translate function.');
    }
};
